import React, { Component, Fragment } from 'react';
import { Button, Icon, Tag, Result, Tooltip, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from "react-i18next";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import * as Func from '../../../../../helpers/functions';
import { PageListComponent, HeaderListComponent, ListComponent, FilterDropdown } from "../../../common/component/Index";
import Ripple from '../../../common/component/Ripple';
import { FlagIcons } from "../../../common/component/TranslateButton";
import { getCondiments, getProperties, syncCondiments } from '../../../../../actions/fnbAction';
import Wrapper from "../../../common/component/Wrapper";
import AntSelect, { AntOption } from "../../../common/component/AntSelect";
import Span from "../../../common/component/Span";

let permisionActions = {};
const pageSize = 10;

class Condiment extends Component {
    state = {
        filters: {
            PageIndex: 1,
            PageSize: pageSize,
        },
        propertyId: null,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT);
        if (!permisionActions || !permisionActions.allowView) {
            return;
        }
        this.props.actions.getProperties();
        this.props.actions.getCondiments(this.state.filters);
    }

    buildFilters = (pagination, filters, sorter) => {
        const currentFilters = this.state.filters || {};
        const hasNameKey = Object.prototype.hasOwnProperty.call(filters || {}, 'name');
        const hasStatusKey = Object.prototype.hasOwnProperty.call(filters || {}, 'isActive');
        const nameFilterRaw = filters?.name;
        const statusFilterRaw = filters?.isActive;
        const nameFilter = Array.isArray(nameFilterRaw) ? nameFilterRaw[0] : undefined;
        const statusFilter = Array.isArray(statusFilterRaw) ? statusFilterRaw[0] : undefined;
        const nameEmpty = typeof nameFilter === 'string' && nameFilter.trim() === '';
        const nameCleared = (hasNameKey && Array.isArray(nameFilterRaw) && nameFilterRaw.length === 0) || nameEmpty;
        const statusCleared = hasStatusKey && Array.isArray(statusFilterRaw) && statusFilterRaw.length === 0;
        const searchTerm = nameCleared
            ? undefined
            : (nameFilter === undefined || nameEmpty ? currentFilters.SearchTerm : nameFilter);
        const isActive = statusCleared ? undefined : (statusFilter !== undefined ? statusFilter : currentFilters.IsActive);
        const orderBy = sorter?.order ? sorter.field : undefined;
        const orderByDesc = sorter?.order ? sorter.order === 'descend' : undefined;
        const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
        const pageSizeValue = pagination?.pageSize || currentFilters.PageSize || pageSize;
        const changedFilters =
            searchTerm !== currentFilters.SearchTerm ||
            isActive !== currentFilters.IsActive ||
            orderBy !== currentFilters.OrderBy ||
            orderByDesc !== currentFilters.OrderByDesc;
        return Func.removeObjectNull({
            PageIndex: changedFilters ? 1 : pageIndex,
            PageSize: pageSizeValue,
            SearchTerm: searchTerm,
            IsActive: isActive,
            PropertyId: currentFilters.PropertyId,
            OrderBy: orderBy,
            OrderByDesc: orderByDesc,
        });
    };

    handleChange = (pagination, filters, sorter) => {
        const nextFilters = this.buildFilters(pagination, filters, sorter);
        this.setState({ filters: nextFilters });
        this.props.actions.getCondiments(nextFilters);
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(
            (option?.props?.children || '')?.toString().toLowerCase()
        );
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onChangeProperty = (value) => {
        const nextFilters = Func.removeObjectNull({
            ...this.state.filters,
            PageIndex: 1,
            PropertyId: value ?? null,
        });
        this.setState({ filters: nextFilters, propertyId: value ?? null });
        this.props.actions.getCondiments(nextFilters);
    };

    render() {
        const { t, condiments, condimentsPagination, loading, error, properties, condimentSyncing } = this.props;
        const canSync = permisionActions && permisionActions.allowSync;
        const { filters, propertyId } = this.state;
        const pageIndex = condimentsPagination?.pageIndex || filters.PageIndex || 1;
        const pageSizeValue = condimentsPagination?.pageSize || filters.PageSize || pageSize;
        const propertyList = properties || [];
        const columns = [
            {
                title: t('item.fnb.condiment.code'),
                dataIndex: 'code',
                key: 'code',
                sorter: true,
            },
            {
                title: t('item.fnb.condiment.name'),
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => (
                   <Tooltip title={text}><div>{text}</div></Tooltip>
                )
            },
            {
                title: 'No price',
                dataIndex: 'isNoPrice',
                key: 'isNoPrice',
                render: (isNoPrice) => (
                    isNoPrice ? <Tag color="orange">Yes</Tag> : <Tag>No</Tag>
                )
            },
            { title: 'Min', dataIndex: 'minSelection', key: 'minSelection', sorter: true },
            { title: 'Max', dataIndex: 'maxSelection', key: 'maxSelection', sorter: true },
            {
                title: t('item.fnb.condiment.status'),
                dataIndex: 'isActive',
                key: 'isActive',
                filters: [
                    { value: true, text: t('item.fnb.condiment.active') },
                    { value: false, text: t('item.fnb.condiment.inactive') },
                ],
                filterMultiple: false,
                filteredValue: filters.IsActive !== undefined ? [filters.IsActive] : null,
                render: (isActive, record) => {
                    const active =
                        typeof isActive === 'boolean' ? isActive : Boolean(record.status);
                    return active
                        ? <Tag color="green">{t('item.fnb.condiment.active')}</Tag>
                        : <Tag color="red">{t('item.fnb.condiment.inactive')}</Tag>;
                }
            },
            {
                title: t('item.fnb.condiment.translations'),
                dataIndex: 'translations',
                key: 'translations',
                render: (translations) => <FlagIcons languages={translations || []} />
            },
            {
                title: t('action.action'),
                key: 'action',
                align: 'right',
                render: (text, record) => (
                    <Link to={Func.getPathWithParams(PATHS.FNB.CONDIMENT_MANAGER.DETAIL.path, { id: record.id })}>
                        <Icon type="form" className="fs20 colorPrimary" />
                    </Link>
                )
            },
        ];

        if (!permisionActions || !permisionActions.allowView) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle={t('item.fnb.condiment.unauthorized') || "Bạn không có quyền truy cập vào khu vực này"}
                />
            );
        }

        if (error && error.status === 403) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle="Backend API trả về 403. Vui lòng kiểm tra permission ở backend hoặc liên hệ quản trị viên."
                    extra={
                        <Button type="primary" onClick={() => window.location.reload()}>
                            Tải lại trang
                        </Button>
                    }
                />
            );
        }

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        titleHeader={t('navigation.condiment')}
                        extraBreadcrumbs={[{ title: t('navigation.condiment') }]}
                        componentRight={
                            canSync && propertyId ? (
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button
                                        icon="sync"
                                        className="btn btn-primary"
                                        loading={condimentSyncing}
                                        onClick={this.onSync}
                                    >
                                        {t('action.sync')}
                                    </Button>
                                </Ripple>
                            ) : null
                        }
                    />
                    <Wrapper className="row col-md-12 p-2" style={{ marginBottom: "1rem" }}>
                        <Wrapper className="col-md-4">
                            <Span>{t('item.property.title') || 'Property'}:</Span>
                            <AntSelect
                                className="select-departure"
                                showArrow
                                showSearch
                                allowClear
                                placeholder={t('item.property.title') || 'Property'}
                                value={propertyId}
                                onChange={this.onChangeProperty}
                                style={{ width: "100%" }}
                                filterOption={this.selectFilterSearch}
                            >
                                <AntOption value={null}>Tất cả</AntOption>
                                {(propertyList || []).map((property) => (
                                    <AntOption key={property.id} value={property.id}>
                                        {property.name || property.code || property.id}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </Wrapper>
                    </Wrapper>
                    <ListComponent
                        tableKey="condiment-list"
                        classChildren="p-0"
                        classParent="m-0"
                        rowKey={(record, index) => record.id || index}
                        loading={{ spinning: loading, size: "large" }}
                        dataSource={condiments || []}
                        columns={columns}
                        onChange={this.handleChange}
                        pagination={{
                            total: condimentsPagination?.totalCount || 0,
                            totalPage: condimentsPagination?.totalPage || 0,
                            defaultCurrent: pageIndex,
                            defaultPageSize: pageSizeValue,
                        }}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onSync = () => {
        const { t } = this.props;
        const { propertyId, filters } = this.state;
        if (!propertyId) {
            return;
        }
        Modal.confirm({
            title: t('action.sync'),
            content: t('notification.confirmSyncDataCondiment') || 'Bạn có chắc chắn muốn đồng bộ dữ liệu?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.syncCondiments({ propertyId, filters });
            },
        });
    };
}

const mapStateToProps = (state) => ({
    condiments: state.fnbReducer.condiments,
    condimentsPagination: state.fnbReducer.condimentsPagination,
    loading: state.fnbReducer.loading,
    error: state.fnbReducer.error,
    properties: state.fnbReducer.properties,
    condimentSyncing: state.fnbReducer.condimentSyncing,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getCondiments,
            getProperties,
            syncCondiments,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Condiment));
